import React, { useEffect, createElement } from 'react';
interface SEOProps {
  title: string;
  description: string;
}
export function SEO({
  title,
  description
}: SEOProps) {
  useEffect(() => {
    // Update title
    document.title = title;
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);
    // Cleanup function to reset on unmount (optional)
    return () => {
      document.title = 'Precision Pro Sprayers';
    };
  }, [title, description]);
  return null;
}